module.exports = __webpack_public_path__ + "img/yidao-img.20c3f006.jpg";